module.exports = __webpack_public_path__ + "static/img/Rectangle.7f9a7a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Rectangle.png
// module id = /R0Y
// module chunks = 19